<div class="form-check form-switch">
  <input type="checkbox" class="form-check-input" [id]="name" (click)="updateSwitch()" [(ngModel)]="selectedValue">
  <label class="form-check-label" [for]="name">{{ translation | translate}}</label>
</div>
